// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RightPanel — three sleek scenario cards */

.right-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.right-panel-header {
  margin-bottom: 20px;
}

.right-panel-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.right-panel-title {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.3px;
}

.right-panel-subtitle {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #9a8fa3;
  line-height: 1.5;
}

.update-time-btn {
  padding: 6px 13px;
  border-radius: 999px;
  border: 1px solid rgba(192, 132, 252, 0.28);
  background: rgba(192, 132, 252, 0.06);
  color: rgba(226, 214, 236, 0.9);
  font-size: 0.78rem;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.update-time-btn:hover {
  border-color: #c084fc;
  color: #c084fc;
  transform: translateY(-1px);
}

/* Card stack — three confident choices */
.cards-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scenario-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 74px;
  padding: 16px 18px;
  text-align: left;
  background: linear-gradient(150deg, #1a121e 0%, #100b14 100%);
  border: 1.5px solid #2f2733;
  border-radius: 18px;
  color: #ece4f0;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

/* subtle sheen that sweeps on hover */
.scenario-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(120% 120% at 0% 0%, rgba(192, 132, 252, 0.10), transparent 45%);
  opacity: 0;
  transition: opacity 0.16s ease;
  pointer-events: none;
}

.scenario-card:hover:not(:disabled) {
  border-color: #c084fc;
  box-shadow: 0 10px 30px rgba(192, 132, 252, 0.22);
  transform: translateY(-2px);
}

.scenario-card:hover:not(:disabled)::after { opacity: 1; }
.scenario-card:active:not(:disabled) { transform: translateY(0); }

.scenario-card:disabled { opacity: 0.5; cursor: not-allowed; }

.card-emoji {
  font-size: 26px;
  line-height: 1;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4));
}

.card-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}

.card-label {
  font-size: 15px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.2px;
}

.card-desc {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: #a99bb2;
}

.card-arrow {
  font-size: 18px;
  color: #5c5063;
  flex-shrink: 0;
  transition: transform 0.16s ease, color 0.16s ease;
}

.scenario-card:hover:not(:disabled) .card-arrow {
  color: #c084fc;
  transform: translateX(3px);
}

.scenario-card.loading {
  border-color: #c084fc;
  box-shadow: 0 0 18px rgba(192, 132, 252, 0.25);
  cursor: wait;
  justify-content: center;
}

.card-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(192, 132, 252, 0.25);
  border-top-color: #c084fc;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

/* Error */
.right-panel .error-message {
  margin-top: 12px;
  padding: 10px 13px;
  border-radius: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(224, 85, 85, 0.1);
  border: 1px solid rgba(224, 85, 85, 0.35);
  color: #ff8a8a;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightPanel.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;EAC3F,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA,6CAA6C,UAAU,EAAE;AACzD,uCAAuC,wBAAwB,EAAE;;AAEjE,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;AAChB","sourcesContent":["/* RightPanel — three sleek scenario cards */\n\n.right-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.right-panel-header {\n  margin-bottom: 20px;\n}\n\n.right-panel-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.right-panel-title {\n  margin: 0 0 6px 0;\n  font-size: 18px;\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: 0.3px;\n}\n\n.right-panel-subtitle {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #9a8fa3;\n  line-height: 1.5;\n}\n\n.update-time-btn {\n  padding: 6px 13px;\n  border-radius: 999px;\n  border: 1px solid rgba(192, 132, 252, 0.28);\n  background: rgba(192, 132, 252, 0.06);\n  color: rgba(226, 214, 236, 0.9);\n  font-size: 0.78rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.update-time-btn:hover {\n  border-color: #c084fc;\n  color: #c084fc;\n  transform: translateY(-1px);\n}\n\n/* Card stack — three confident choices */\n.cards-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.scenario-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  min-height: 74px;\n  padding: 16px 18px;\n  text-align: left;\n  background: linear-gradient(150deg, #1a121e 0%, #100b14 100%);\n  border: 1.5px solid #2f2733;\n  border-radius: 18px;\n  color: #ece4f0;\n  cursor: pointer;\n  overflow: hidden;\n  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;\n}\n\n/* subtle sheen that sweeps on hover */\n.scenario-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(120% 120% at 0% 0%, rgba(192, 132, 252, 0.10), transparent 45%);\n  opacity: 0;\n  transition: opacity 0.16s ease;\n  pointer-events: none;\n}\n\n.scenario-card:hover:not(:disabled) {\n  border-color: #c084fc;\n  box-shadow: 0 10px 30px rgba(192, 132, 252, 0.22);\n  transform: translateY(-2px);\n}\n\n.scenario-card:hover:not(:disabled)::after { opacity: 1; }\n.scenario-card:active:not(:disabled) { transform: translateY(0); }\n\n.scenario-card:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.card-emoji {\n  font-size: 26px;\n  line-height: 1;\n  flex-shrink: 0;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4));\n}\n\n.card-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n  min-width: 0;\n}\n\n.card-label {\n  font-size: 15px;\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: 0.2px;\n}\n\n.card-desc {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #a99bb2;\n}\n\n.card-arrow {\n  font-size: 18px;\n  color: #5c5063;\n  flex-shrink: 0;\n  transition: transform 0.16s ease, color 0.16s ease;\n}\n\n.scenario-card:hover:not(:disabled) .card-arrow {\n  color: #c084fc;\n  transform: translateX(3px);\n}\n\n.scenario-card.loading {\n  border-color: #c084fc;\n  box-shadow: 0 0 18px rgba(192, 132, 252, 0.25);\n  cursor: wait;\n  justify-content: center;\n}\n\n.card-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(192, 132, 252, 0.25);\n  border-top-color: #c084fc;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Error */\n.right-panel .error-message {\n  margin-top: 12px;\n  padding: 10px 13px;\n  border-radius: 10px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(224, 85, 85, 0.1);\n  border: 1px solid rgba(224, 85, 85, 0.35);\n  color: #ff8a8a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
